var map = {
	"./a4.png": "MjCJ",
	"./a4en.png": "X0mq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "t7YT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet ^\.\/a4.*\.png$
// module id = t7YT
// module chunks = 0